import React, { useEffect, useState } from "react";
import { useQuoteRecap } from "../../../../../providers/quoteRecapProvider";
import { utils } from "../../../../../utils/utils";

const QuoteTotalSubContractorsSectionTotal = ({
  quoteItemSubcontractorRoles,
}) => {
  const [quoteRecapContext] = useQuoteRecap();

  const [cost, setCost] = useState(0);
  const [sale, setSale] = useState(0);

  useEffect(() => {
    const cost = quoteItemSubcontractorRoles.reduce(
      (p, c) => p + parseFloat(c.cost),
      0
    );
    const sale = quoteItemSubcontractorRoles.reduce((p, c) => {
      const cost = c.cost || 0;
      const sale = cost * (1 + quoteRecapContext.markupPercentage / 100);
      return p + sale;
    }, 0);
    setCost(cost);
    setSale(sale);
  }, [quoteRecapContext.markupPercentage, quoteItemSubcontractorRoles]);

  return (
    <tr>
      <td className="font-weight-bold py-0" width={"40%"}>
        Total Subcontractors
      </td>
      <td className="py-0" width={"15%"} />
      <td className="py-0" width={"15%"}>
        <div
          readOnly
          className="form-control border text-right m-1 font-weight-bold"
        >
          {utils.formatCurrency(cost)}
        </div>
      </td>
      <td className="py-0" width={"15%"} />
      <td className="py-0" width={"15%"}>
        <div
          readOnly
          className="form-control border text-right m-1 font-weight-bold"
        >
          {utils.formatCurrency(sale)}
        </div>
      </td>
    </tr>
  );
};

export default QuoteTotalSubContractorsSectionTotal;
